import {Validators} from '@angular/forms';

import {ComponentTypesEnum, ColorCodesEnum} from '../../../app/shared/enums';
import {BaseControl, CheckboxControl} from '../../../app/shared/classes/controls';

export const IdentificationNumberUseTaxNumberSelector = 'useTaxNumber';
export const IdentificationNumberSelector = 'identificationNumber';

export const IdentificationNumberMaxLength = 30;

export interface IdentificationNumberControlsInterface {
    useTaxNumber: CheckboxControl;
    identificationNumber: BaseControl;
}

/**
 * CRM-5286 / CRM-5232: the Identification Number capture block on the tax step.
 *
 * Named keys rather than an array: the tax details next door are addressed positionally
 * (controls[1], controls[2]) and that is exactly what makes them fragile to extend. These two
 * controls are also per-client, not per tax record, so they deliberately live outside the
 * taxDetails FormArray - putting them inside it would break its positional template, its
 * dirty-checking and its empty-row pruning.
 */
export const IdentificationNumberControls = (): IdentificationNumberControlsInterface => {
    return {
        useTaxNumber: new CheckboxControl({
            name: IdentificationNumberUseTaxNumberSelector,
            value: false,
            // nonCapitalizedPlaceholder, or BaseControl title-cases this into
            // "Id Number Is The Same As Tax Number".
            placeholder: 'ID number is the same as tax number',
            nonCapitalizedPlaceholder: true,
            validators: [],
            componentType: ComponentTypesEnum.Checkbox,
            invalid: false,
            floatingLabelNever: true,
            expectBooleanValue: true,
            checked: false,
            color: ColorCodesEnum.Primary
        }),
        identificationNumber: new BaseControl({
            name: IdentificationNumberSelector,
            value: '',
            placeholder: 'Identification number',
            // Required is bound at runtime instead of declared here: it applies only while the
            // checkbox is unticked. See IdentificationNumberForm.bindIdentificationNumberValidators.
            validators: [Validators.maxLength(IdentificationNumberMaxLength)],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        })
    };
};
